export const useGuideShareLinks = () => {
    function getEventViewLink(guide: {
        customPath: string;
        guideType: string;
        guideId: string;
        worldMapId: string;
    }) {
        if (guide.guideId && guide.guideType === 'guide') {
            return `https://welcome.mapheim.com/${guide.customPath ?? guide.guideId}`;
        }
        if (guide.guideId && guide.guideType === 'map') {
            return `${location.protocol}//${location.host}/map2/${guide?.worldMapId}`;
        }

        return guide.customPath
            ? `${location.protocol}//${location.host}/event/${guide.customPath}`
            : `${location.protocol}//${location.host}/event/${guide.guideId}`;
    }

    function getMapViewLink(guide: { worldMapId: string; guideId: string; guideType: string }) {
        if (guide.guideId && guide.guideType === 'map') {
            return `${location.protocol}//${location.host}/map2/${guide?.worldMapId}`;
        }
        return `${location.protocol}//${location.host}/map/${guide?.worldMapId}`;
    }

    function getMapIframe(guide: {
        guideId: string;
        worldMapId: string;
        guideType: string;
        title: string;
        customPath: string;
    }) {
        if (guide.guideType === 'map') {
            const mapViewLink = getEventViewLink(guide);
            const scriptUrl = 'https://app.mapheim.com/embed/iframe-map2-embed.js';
            return `
                <iframe
                    id="mapheim_iframe"
                    class="mapheim_iframe_class"
                    style="margin: 0 auto; outline: none; border: none; display: block; max-width: 100%"
                    src="${mapViewLink}?lang=en"
                    width="1400px"
                    height="500px"
                    onload="window.mapheim_init_map && window.mapheim_init_map(event)"
                ></iframe>
                <script src="${scriptUrl}"></script>
            `;
        }

        const mapViewLink = getMapViewLink(guide);
        return `<iframe width="100%" height="500" frameborder="0" title="${guide.title}" src="${mapViewLink}?iframe=true&interactivityType=popup"></iframe>`;
    }

    return {
        getEventViewLink,
        getMapViewLink,
        getMapIframe
    };
};
